(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-upsells"] && !Shopify.designMode) return;
  try {
    customElements.define(
    'cart-drawer-upsells',
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.flickityInstance = null;
        this.productId = this.dataset.productId;
        this.url = this.dataset.url;
        this.container = this.querySelector('[data-upsells-container]');

        this.init();
      }

      /**
       * Initialize the component with IntersectionObserver
       * @returns {void}
       */
      async init() {
        const handleIntersection = async (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          await this.loadRecommendations();
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: '0px 0px 200px 0px',
        }).observe(this);

        document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));
        document.addEventListener('product:added-from-modal', this.handleProductAddedFromModal.bind(this));
      }

      /**
       * Handle product added from modal event
       * @returns {Promise<void>}
       */
      async handleProductAddedFromModal() {
        await this.loadRecommendations();
      }

      /**
       * Handle cart update event
       * @param {CustomEvent} event - Cart update event
       * @returns {Promise<void>}
       */
      async handleCartUpdate(event) {
        if (!event.detail || !event.detail.cart) return;

        const firstItem = event.detail.cart.items?.[0];

        if (!firstItem) {
          return;
        }

        if (firstItem.product_id !== parseInt(this.productId)) {
          this.productId = firstItem.product_id;
          this.url = `${window.Shopify.routes.root}recommendations/products?section_id=cart-drawer-upsells&product_id=${this.productId}&limit=5`;
          await this.loadRecommendations();
        }
      }

      /**
       * Load product recommendations from API
       * @returns {Promise<void>}
       */
      async loadRecommendations() {
        if (!this.url || !this.container) return;

        try {
          const response = await fetch(this.url);
          if (!response.ok) throw new Error('Failed to fetch recommendations');

          const text = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');

          const productsContainer = doc.querySelector('[data-upsells-container]');

          if (!productsContainer || productsContainer.children.length === 0) {
            this.style.display = 'none';
            return;
          }

          if (this.flickityInstance) {
            this.flickityInstance.destroy();
            this.flickityInstance = null;
          }

          this.container.innerHTML = productsContainer.innerHTML;

          const products = this.querySelectorAll('.cart-drawer-upsells__item');
          products.forEach((product) => {
            const handle = product.dataset.productHandle;
            const productId = product.dataset.productId;
            const btn = product.querySelector('.quick-product__btn--not-ready');

            if (btn && typeof theme !== 'undefined' && theme.preloadProductModal) {
              window.theme.preloadProductModal(handle, productId, btn);
            }
          });

          this.style.display = '';

          await this.initSlider();
        } catch (error) {
          this.style.display = 'none';
        }
      }

      /**
       * Initialize Flickity slider
       * @returns {Promise<void>}
       */
      async initSlider() {
        return new Promise((resolve) => {
          const interval = setInterval(() => {
            if (typeof Flickity !== 'undefined') {
              clearInterval(interval);

              if (this.container && this.container.children.length > 0) {
                this.flickityInstance = new Flickity(this.container, {
                  cellAlign: 'left',
                  pageDots: true,
                  contains: true,
                  prevNextButtons: false,
                  wrapAround: false,
                  freeScroll: false,
                  groupCells: true,
                  dragThreshold: 10,
                  adaptHeight: true,
                  selectedAttraction: 0.2,
                  friction: 0.8,
                  marginRight: 8,
                });
              }

              resolve();
            }
          }, 100);
        });
      }

      /**
       * Cleanup on component removal
       * @returns {void}
       */
      disconnectedCallback() {
        if (this.flickityInstance) {
          this.flickityInstance.destroy();
        }
        document.removeEventListener('cart:updated', this.handleCartUpdate.bind(this));
        document.removeEventListener('product:added-from-modal', this.handleProductAddedFromModal.bind(this));
      }
    }
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block--promo-event"] && !Shopify.designMode) return;
  try {
    class PromoEventTimer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.eventDate = this.dataset.eventDate;
      this.timerElements = {
        days: this.querySelector('[data-timer="days"]'),
        hours: this.querySelector('[data-timer="hours"]'),
        minutes: this.querySelector('[data-timer="minutes"]'),
      };
      this.interval = null;

      this.init();
    }

    init() {
      if (!this.eventDate) return;

      this.updateTimer();
      this.interval = setInterval(() => this.updateTimer(), 60000);

      this.setupModal();
    }

    parseDate(dateString) {
      // Handle ISO 8601 format: 2025-08-06T07:30:00Z
      return new Date(dateString);
    }

    updateTimer() {
      const now = new Date();
      const eventDate = this.parseDate(this.eventDate);
      const timeDiff = eventDate - now;

      if (timeDiff <= 0) {
        this.timerElements.days.textContent = '0';
        this.timerElements.hours.textContent = '0';
        this.timerElements.minutes.textContent = '0';
        if (this.interval) {
          clearInterval(this.interval);
        }
        return;
      }

      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

      this.timerElements.days.textContent = days;
      this.timerElements.hours.textContent = hours;
      this.timerElements.minutes.textContent = minutes;
    }

    setupModal() {
      const modalTrigger = this.querySelector('[data-modal-trigger]');
      const modal = document.getElementById('promo-event-modal');
      const modalClose = modal?.querySelector('[data-modal-close]');

      if (modalTrigger && modal) {
        modalTrigger.addEventListener('click', () => {
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      }

      if (modalClose && modal) {
        modalClose.addEventListener('click', () => {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }

      if (modal) {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          }
        });
      }
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  customElements.define('promo-event-timer', PromoEventTimer);
  } catch(e) { console.error(e); }
})();

})();
